module.exports = __webpack_public_path__ + "static/media/violinplay_callbackhell.4fea0921.wav";